import { CapTableForm } from './ui/Form';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { CapTableDocument, useCapTableQuery, useUpdateCapTableMutation } from './cap-table.graphql';
import { StakeKind } from '@startuptools/common/cap-table';
import { DateTime } from 'luxon';

export const EditCapTable = ({ close, id }: { close: () => void; id: string }) => {
  const companyId = useCompanyId();
  const { data } = useCapTableQuery({ variables: { companyId, id } });

  const [updateCapTable, { error, loading }] = useUpdateCapTableMutation({ refetchQueries: [CapTableDocument] });
  if (!data?.capTable) {
    return null;
  }
  const { capTable } = data;
  return (
    <CapTableForm
      mode="edit"
      loading={loading}
      hasWise={data.capTable.stakeholders.flatMap(s => s.stakes).some(s => s.kind === StakeKind.Wise)}
      error={Boolean(error)}
      onCancel={() => close()}
      onSubmit={async ({ recordDate, ...formData }) => {
        await updateCapTable({
          variables: {
            companyId,
            input: {
              id: capTable.id,
              recordDate: recordDate?.toUTC().toString() ?? null,
              ...formData,
            },
          },
        });
        close();
      }}
      defaultValues={{
        displayName: capTable.displayName ?? '',
        pricePerShare: capTable.pricePerShare ?? '',
        unregisteredShares: capTable.unregisteredShares ?? '',
        fullyDiluted: capTable.fullyDiluted,
        recordDate: capTable.recordDate ? DateTime.fromISO(capTable.recordDate) : null,
      }}
    />
  );
};
